import {
  GA4_ECOM_CUSTOM_EVENTS,
  GA4_EVENTS,
  GA4_PURCHASE_TYPES,
  type PurchaseTypes,
} from '../types'

const getEcomCustomEventFromPurchaseType = (purchaseType: PurchaseTypes) => {
  if (purchaseType === GA4_PURCHASE_TYPES.CONSULTATIONS) {
    return GA4_ECOM_CUSTOM_EVENTS.PURCHASE_CONSULTATION
  }
  if (purchaseType === GA4_PURCHASE_TYPES.GIFT_CARD) {
    return GA4_ECOM_CUSTOM_EVENTS.PURCHASE_GIFTCARD
  }
  if (purchaseType === GA4_PURCHASE_TYPES.PROCUREMENT) {
    return GA4_ECOM_CUSTOM_EVENTS.PURCHASE_PROCUREMENT
  }
  return GA4_ECOM_CUSTOM_EVENTS.PURCHASE_SHOWROOM
}

export const trackPurchasesToGA4 = ({
  purchaseType,
  paymentMethod,
  executeDataToDataLayer,
  checkoutResponse,
  extra = {},
}) => {
  executeDataToDataLayer({
    event: GA4_EVENTS.PURCHASE,
    overrideData: {
      purchaseType,
      paymentMethod,
      checkoutResponse,
      extra,
    },
  })

  executeDataToDataLayer({
    event: getEcomCustomEventFromPurchaseType(purchaseType),
    includeStoredData: false,
  })
}
